import {
  INITIALIZE_DATA_SUCCESS,
  FETCH_ROUTES_REQUEST,
  FETCH_ROUTES_SUCCESS,
  FETCH_ROUTES_FAILURE,
  SELECTED_MFC,
  TOGGLE_LEGEND,
  OPEN_MOBILE_MAP,
  CLOSE_MOBILE_MAP,
  CLEAR_ROUTES,
  RESET_FILTERS_SERVICES,
  CHANGE_FILTER,
  SEARCH_FILTERS,
  TOGGLE_SHOW_SERVICES,
  TOGGLE_SHOW_OFFICE_SERVICES,
  RESET_FILTERS,
  INITIALIZE_FILTERS,
  APPLY_FILTERS,
  INITIALIZE_SERVICES_CATALOG,
  FETCH_CATALOG_FOR_OFFICE_REQUEST,
  FETCH_CATALOG_FOR_OFFICE_SUCCESS,
  FETCH_CATALOG_FOR_OFFICE_ERROR,
  SELECT_NEAREST_MFC,
} from './constants';
import getMetroStations from '@store/services/getMetroStations';
import { fetchGeoApi, fetchRoutesApi } from '@store/resources';
import getStartPoints from '@store/services/getStartPoints';
import routesSerializer from '@store/services/routesSerializer';
import routesSorting from '@store/services/routesSorting';
import { routesSelector } from '@selectors/routesSelector';
import { fetchGET } from '@store/resources/fetchHelper';
import formatCatalogToClient from '@helpers/formatServicesCatalogToClient';
import { prepareOffices } from '@helpers/filtersHelpers';

export const fetchRoutesRequest = (payload) => ({
  type: FETCH_ROUTES_REQUEST,
  payload,
});
export const onRoutesSuccess = (payload) => ({
  type: FETCH_ROUTES_SUCCESS,
  payload,
});
export const onRoutesFailure = (payload) => ({
  type: FETCH_ROUTES_FAILURE,
  payload,
});
export const onRoutesClear = () => ({
  type: CLEAR_ROUTES,
});
export const onSelectMfc = (payload) => (dispatch, getState) => {
  const { undergrounds } = getState().data;
  const { id } = payload || {};
  const stations = getMetroStations(payload?.address, undergrounds);
  if (stations) {
    const routesArray = async () => {
      dispatch(fetchRoutesRequest());

      const fetchedStartPoints = Promise.all(
        stations.map((station) => fetchGeoApi(station.name))
      );

      const startPoints = await fetchedStartPoints;
      const startPointsSerialize = getStartPoints({
        response: startPoints,
        selectedMfc: payload,
      });

      return Promise.all(
        startPointsSerialize.map((startPoint) => {
          const getRouteThisPoint = async () => {
            const { responseParams } = startPoint;
            const results = await fetchRoutesApi(responseParams);
            return routesSerializer(results, startPoint, undergrounds);
          };
          return getRouteThisPoint();
        })
      );
    };

    routesArray()
      .then((routesStartPoints) => {
        const routes = routesSorting(routesStartPoints);
        dispatch(onRoutesSuccess(routes));
      })
      .catch((error) => {
        dispatch(onRoutesFailure(error));
      });
  }

  if (id) {
    dispatch(fetchCatalogForOfficeRequest());
    fetchGET(`/api/mfc/v1/mfccatalog/${id}/`)
      .then((data) => {
        dispatch(fetchCatalogForOfficeSuccess(data));
      })
      .catch(() => {
        dispatch(fetchCatalogForOfficeError());
      });
  }

  dispatch({
    type: SELECTED_MFC,
    payload,
  });
};

export const selectedRouteAction = (payload) => (dispatch, getState) => {
  const state = getState();
  const routes = routesSelector(state);

  const prepareRoutes = routes.map((item) => {
    if (item.routeId === payload) {
      if (item.selected) {
        return {
          ...item,
          selected: false,
          routeStyleHide: true,
        };
      }
      return {
        ...item,
        selected: true,
        routeStyleHide: false,
      };
    }
    return {
      ...item,
      selected: false,
      routeStyleHide: false,
    };
  });

  dispatch(onRoutesSuccess(prepareRoutes));
};

export const toggleLegend = (payload) => ({
  type: TOGGLE_LEGEND,
  payload,
});
export const openMobileMap = () => ({
  type: OPEN_MOBILE_MAP,
});
export const closeMobileMap = () => ({
  type: CLOSE_MOBILE_MAP,
});

export const changeSearchValueServices = (value) => ({
  type: SEARCH_FILTERS,
  payload: { fieldName: 'services', value },
});

export const changeSearchValue = (payload) => ({
  type: SEARCH_FILTERS,
  payload,
});

export const toggleShowServices = (value) => ({
  type: TOGGLE_SHOW_SERVICES,
  payload: { fieldName: 'services', value },
});

export const toggleShowOfficeServices = (value) => ({
  type: TOGGLE_SHOW_OFFICE_SERVICES,
  payload: { fieldName: 'services', value },
});

export const resetServicesFilters = () => ({
  type: RESET_FILTERS_SERVICES,
});

export const changeFilter = (payload) => ({
  type: CHANGE_FILTER,
  payload,
});

export const resetFilters = () => ({
  type: RESET_FILTERS,
});
export const applyFilters = () => ({
  type: APPLY_FILTERS,
});

export const initializeFilters = (payload) => ({
  type: INITIALIZE_FILTERS,
  payload,
});

export const initializeServicesCatalog = (payload) => ({
  type: INITIALIZE_SERVICES_CATALOG,
  payload,
});

export const fetchCatalogForOfficeRequest = (payload) => ({
  type: FETCH_CATALOG_FOR_OFFICE_REQUEST,
  payload,
});

export const fetchCatalogForOfficeSuccess = (payload) => ({
  type: FETCH_CATALOG_FOR_OFFICE_SUCCESS,
  payload,
});

export const fetchCatalogForOfficeError = (payload) => ({
  type: FETCH_CATALOG_FOR_OFFICE_ERROR,
  payload,
});

export const selectNearestMfc = (payload) => ({
  type: SELECT_NEAREST_MFC,
  payload,
});

export const initializeAllData = () => (dispatch, getState) => {
  const datas = [
    ['services', 'mfcmap/services'],
    ['areas', 'mfcmap/areas'],
    ['undergrounds', 'mfcmap/undergrounds'],
    ['offices', 'mfcmap/offices'],
    ['schedules', 'mfcmap/schedules'],
    ['auxiliary', 'mfcmap/auxiliary'],
    ['servicesCatalog', 'mfccatalog/'],
  ];

  Promise.all(
    datas.map(([data, request]) => fetchData({ data, request }))
  ).then((responses) => {
    responses.forEach(({ data, result }) => {
      if (data === 'servicesCatalog') {
        dispatch(
          initializeDataSuccess(
            data,
            formatCatalogToClient(result, getState().data.offices)
          )
        );
      } else if (data === 'offices') {
        dispatch(initializeDataSuccess(data, prepareOffices(result)));
      } else {
        dispatch(initializeDataSuccess(data, result));
      }
    });
  });
};

const fetchData = ({ data, request }) => {
  const apiPath = `/api/mfc/v1/`;
  return fetch(apiPath + request)
    .then((res) => {
      return res.json();
    })
    .then((result) => {
      return { data, result };
    });
};

const initializeDataSuccess = (data, result) => ({
  type: INITIALIZE_DATA_SUCCESS,
  payload: { data, result },
});
